import cn from "classnames";
import { Datetime } from "components/shared/form";
import { serializeReq, validateForm } from "helpers/form";
import { requiredField } from "helpers/validators";
import React, { useState } from "react";
import { updateOdometerHistoryItem } from "sources/admin/odometers";

const config = {
    startedAt: {
        inPortal: true,
        label: "Дата начала",
        inputProps: { name: "startedAt", type: "datetime" },
        validators: [requiredField],
        required: true,
    },
    endedAt: {
        inPortal: true,
        label: "Дата окончания",
        inputProps: { name: "endedAt", type: "datetime" },
        required: true,
    },
};

export default function OdometerHistoryForm(props) {
    const [data, setData] = useState(props.data);
    const [loading, setLoading] = useState(false);
    const [valid, setValid] = useState(true);

    const handleSubmit = () => {
        setLoading(true);
        const reqData = {
            id: data.id,
            organizationId: props.organizationId,
            startedAt: data.startedAt,
            endedAt: data.endedAt,
        };
        const serialized = { ...serializeReq(reqData) };
        if (validateForm(config, serialized)) {
            setValid(true);
            updateOdometerHistoryItem(serialized).then((res) => {
                if (res) {
                    props.refreshData();
                    props.back();
                }
                setLoading(false);
            });
        } else {
            setValid(false);
            setLoading(false);
        }
    };

    return (
        <div className={cn({ loading, "book-form__body--invalid": !valid })}>
            <Datetime
                {...config.startedAt}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.startedAt}
            />
            <Datetime
                {...config.endedAt}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.endedAt}
            />
            <div className="d-flex justify-content-end">
                <div className="btn btn-sm btn-brand" onClick={handleSubmit}>
                    Сохранить
                </div>
            </div>
        </div>
    );
}
